<template>
    <div class="evo-h-full evo-w-full evo-flex-1 evo-flex">
        <evo-language-selector></evo-language-selector>
        <slot></slot>
    </div>
</template>

<script setup>
import EvoLanguageSelector from '../components/evo-language-selector/evo-language-selector.vue';
</script>
